export default __webpack_public_path__ + "static/media/RCTQ.a55b9793.JPG";